export function noop() {
    // This function is intentionally empty.
}
export function identity(a) {
    return a;
}
